import angular from 'angular';
import constants from 'app/constants';
import {
  controlDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './delete-control-type-confirm-dialog.controller';
import template from './delete-control-type-confirm-dialog.html';

class dialogService {
  getOptions($event, {
    controlType, riskType
  }) {
    return {
      controller,
      controllerAs: 'deleteControlTypeConfirmDialogVM',
      locals: {
        controlType,
        riskType,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.control.deleteControlTypeConfirmDialog', [
  alerts,
  controlDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('deleteControlTypeConfirmDialog', dialogService)
  .name;
